<div
    class="container-fluid login"
    *ngIf="!didBootstrapInit"
>
    <div class="login-background"></div>
    <div class="login-background-overlay"></div>
    <div class="row login-logo">
        <div class="col-12 h-100">
            <div class="login-compas-logo"></div>
        </div>
    </div>
    <cmps-client-logo [login]="true"></cmps-client-logo>
</div>

<cmps-wait-status
    [ngClass]="{ 'text-white': !didBootstrapInit }"
    [background]="didBootstrapInit"
    [fixed]="true"
    [modal]="true"
    [status]="initStatus"
    [srStatus]="'Loading'"
    *ngIf="isInitRunning || isLazyLoading"
></cmps-wait-status>

<ng-container
    *ngIf="
        ((isAuthenticated && didInit) || isReAuthenticating) &&
        !isPaused &&
        !isAtNonNavRoute
    "
>
    <a
        class="sr-only sr-only-focusable"
        href
        (click)="skipToMainContent($event)"
        >Skip to main content</a
    >
    <cmps-nav></cmps-nav>
    <cmps-notification-panel></cmps-notification-panel>
</ng-container>

<main
    id="cmpsMain"
    tabindex="-1"
    *ngIf="didBootstrapInit"
>
    <router-outlet></router-outlet>
</main>

<cmps-debug-panel></cmps-debug-panel>
